module.exports = __webpack_public_path__ + "img/HQ-PA050W2T2RS.1d738f74.jpg";